import { Injectable } from '@angular/core';

import { InstrumentationParam, InstrumentationParams, InstrumentationService, KnownInstrumentationEvents } from '../shared/instrumentation/instrumentation.service';
import { SchedulePriority, SchedulerService } from '../shared/services/scheduler.service';
import { WindowService } from '../shared/services/window.service';

interface MemoryBreakdown {
    attribution: Array<Attribution>;
    bytes: number;
    types: Array<string>;
}

interface Attribution {
    scope: string;
    url: string;
}

@Injectable({
    providedIn: 'root'
})
export class MemoryService {
    private readonly currentWindow: Window = this.windowService.nativeWindow;

    constructor(
        private readonly instrumentationService: InstrumentationService,
        private readonly scheduler: SchedulerService,
        private readonly windowService: WindowService
    ) {
    }

    // Logs the memory profile for the window
    // Only called when the Cross-Origin Isolation headers are set
    public getMemoryProfile() {
        if ('measureUserAgentSpecificMemory' in this.currentWindow.performance) {
            this.scheduler.scheduleWork( () => {
                this.currentWindow.performance.measureUserAgentSpecificMemory().then(
                memoryStats => {
                    const totalMemoryUsage = memoryStats.bytes;
                    const memoryBreakdown = this.cleanMemoryBreakdown(memoryStats.breakdown);
                    const params: InstrumentationParams = { [InstrumentationParam.MemoryProfileBreakdown]: JSON.stringify(memoryBreakdown),
                                                            [InstrumentationParam.TotalSize]: totalMemoryUsage };
                    this.instrumentationService.logGenericEvent(KnownInstrumentationEvents.MemoryUsage, params);
                }
            ).catch( () => { /* do nothing */ } );
            }, SchedulePriority.VeryLow );
        }
    }

    private cleanMemoryBreakdown(breakdowns: Array<MemoryBreakdown>) {
        for (const breakdown of breakdowns) {
            const attributions = breakdown.attribution;
            for (const attribution of attributions) {
                const url = new URL(attribution.url);
                attribution.url = url.hostname + url.pathname;
            }
        }
        return breakdowns;
    }
}
